export default __webpack_public_path__ + "img/billet.1a41c55.svg";